import React from 'react';

export interface PinInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
  disabled?: boolean;
  autoFocus?: boolean;
  describedBy?: string;
}

/** 6-digit PIN field (Phase 16A): numeric keypad on phones, masked, digits only. */
const PinInput: React.FC<PinInputProps> = ({ id, label, value, onChange, onComplete, disabled, autoFocus, describedBy }) => (
  <div>
    <label htmlFor={id} className="mb-1 block text-sm font-medium text-gray-700">{label}</label>
    <input
      id={id}
      type="password"
      inputMode="numeric"
      autoComplete="off"
      maxLength={6}
      value={value}
      disabled={disabled}
      autoFocus={autoFocus}
      aria-describedby={describedBy}
      onChange={(e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
        onChange(digits);
        if (digits.length === 6) onComplete?.(digits);
      }}
      className="w-full rounded-lg border border-gray-300 px-4 py-3 text-center text-2xl tracking-[0.6em] focus:border-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-800/30 disabled:bg-gray-100"
    />
  </div>
);

export default PinInput;
